/**
 * Act 0 — T1 discovery arc. Post-N4 cut: 4 screens (0.1, 0.3, 0.5,
 * 0.6). Legacy 0.2 and 0.4 case clauses remain in SceneRouter for
 * manual /control/seek compatibility but are NOT in the scenario JSON
 * or this registry.
 */

import type { ReactElement } from "react";
import type { Act0Screen } from "@/lib/scenes/screens";
import type { SceneRenderContext } from "@/lib/scenes/act4";
import { AlMadarDiscovery }   from "@/components/scenes/act0/AlMadarDiscovery";
import { EmailMock }          from "@/components/scenes/act0/EmailMock";
import { PublicCataloguePage } from "@/components/scenes/act0/PublicCataloguePage";
import { ProposalGate }       from "@/components/scenes/act0/ProposalGate";

export const ACT0_RENDERERS: Record<Act0Screen, (ctx: SceneRenderContext) => ReactElement> = {
  "0.1": ({ ev }) => <AlMadarDiscovery scenarioRunning={ev.events.length > 0} />,
  "0.3": () => (
    // Two-pane email exchange: Al Madar's outbound mail on the left,
    // Aurora's reply with the public-catalogue link on the right. The
    // inbound variant carries the portfolio-link chip
    // (orbitra.trade/c/aurora-aves/halal-whole-chicken) — surfaced here
    // so the audience sees the round-trip in one beat rather than across
    // two screens.
    <div className="grid h-full grid-cols-2 place-items-center gap-6">
      <EmailMock variant="outbound" />
      <EmailMock variant="inbound" />
    </div>
  ),
  "0.5": () => <PublicCataloguePage />,
  "0.6": () => <ProposalGate />,
};
